import axios from 'axios';
import type { Query, Mutation } from '@tanstack/vue-query';

export const checkFulfilled = <T>(p: PromiseSettledResult<T>): p is PromiseFulfilledResult<T> =>
  p.status === 'fulfilled';
export const checkRejected = <T>(p: PromiseSettledResult<T>): p is PromiseRejectedResult =>
  p.status === 'rejected';

export const isDuplicateNameError = (e: unknown) => {
  return axios.isAxiosError(e) && e.response?.status === 409;
};

export const isCancelError = (e: unknown) => {
  return axios.isAxiosError(e) && e.code === 'ERR_CANCELED';
};

export const isIgnoreRequestError = (error: unknown): boolean => {
  return !!(
    error &&
    typeof error === 'object' &&
    'ignoreRequest' in error &&
    (error as { ignoreRequest?: boolean }).ignoreRequest
  );
};

interface QueryMeta {
  onError?: (error: unknown) => void;
}

/**
 * Vue Query 전역 에러 핸들러 (QueryCache용)
 */
export const handleQueryError = (error: unknown, query: Query<unknown, unknown, unknown>) => {
  if (isCancelError(error) || isIgnoreRequestError(error)) {
    return;
  }

  const meta = query?.meta as QueryMeta | undefined;
  if (meta?.onError) {
    meta.onError(error);
  }
};

/**
 * Vue Query 전역 에러 핸들러 (MutationCache용)
 */
export const handleMutationError = (
  error: unknown,
  _variables: unknown,
  _context: unknown,
  mutation: Mutation<unknown, unknown, unknown>,
) => {
  if (isCancelError(error) || isIgnoreRequestError(error)) {
    return;
  }

  const meta = mutation?.meta as QueryMeta | undefined;
  if (meta?.onError) {
    meta.onError(error);
  }
};
